<template>
    <div class="news">
        <div id="container">
            <img src="../assets/news/banner_2x.png" style="width:90%;">
            <div id="news" v-for="mynews in myNews" :key="mynews.newsTitle">
                <div class="news1">
                    <img :src="mynews.pic">
                    <div class="newsText">
                        <span class="newsTitle" @click="openUrl(mynews.src)">{{mynews.newsTitle}}</span><br>
                        <span class="newsDetail">{{mynews.newsDetail}}</span>
                        <span class="more" @click="openUrl(mynews.src)">详情>></span>
                    </div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
        <customer-service />
    </div>
</template>

<script scoped>
import bus from '@/lib/bus.js'
import news from '@/lib/news-list.js'
import CustomerService from '@/components/CustomerService.vue'

export default {
    name: 'newsPage',
    components: {
        CustomerService
    },
    data () {
        return {
            myNews: news
        }
    },
    mounted () {
		bus.$emit('changeSelectedIndex', 4)
		if (document.documentElement) {
			document.documentElement.scrollTop = 0
		} else {
			document.body.scrollTop = 0
		}
    },
    methods: {
        openUrl (url) {
            window.open(url, '_blank')
        }
    }
}
</script>

<style scoped>
    @import './news.css';
</style>



// WEBPACK FOOTER //
// src/pages/News.vue